import { memo } from 'react';
import { Box, Image, ScrollView, Text } from '@betty/moonlight';
import { useSelector } from '@betty/toolkit/state';
import { QuestsBottomSheetProps, selectActiveQuestsForGame } from '../state';
import QuestProgress from '../components/QuestItem/components/QuestProgress/QuestProgress';
import { QuestStatus } from '../services/QuestsService.schemas';

function QuestsInGameBottomSheet({ gameId }: QuestsBottomSheetProps) {
  const activeQuests = useSelector((state) =>
    selectActiveQuestsForGame(state, gameId),
  );

  return (
    <Box marginTop="space-400" maxHeight={300}>
      <ScrollView showsVerticalScrollIndicator={false}>
        <Box gap="space-200">
          {activeQuests.map((quest) => (
            <Box
              key={quest.promotionId}
              backgroundColor="blackBackground"
              borderRadius="radius-200"
            >
              <Box padding="space-300" gap="space-400">
                <Text variant="caption-semi" color="level_0">
                  {quest.title}
                </Text>
                <Box flexDirection="row" gap="space-200" alignItems="center">
                  {quest?.subTypeMeta ? (
                    <QuestProgress
                      subTypeMeta={quest.subTypeMeta}
                      subPromoType={quest.subPromoType}
                    />
                  ) : null}
                </Box>
              </Box>
              {quest.status === QuestStatus.Completed ? (
                <Box
                  variant="gradient"
                  flexDirection="row"
                  justifyContent="center"
                  gradient="darkSurfaceBrand"
                  borderBottomLeftRadius="radius-200"
                  borderBottomRightRadius="radius-200"
                  paddingVertical="space-100"
                  gap="space-100"
                >
                  <Image
                    name="common.GreenCheck"
                    width="space-400"
                    height="space-400"
                  />
                  <Text
                    variant="caption-semi"
                    locNS="quests"
                    locKey="questCompleted"
                    color="accentSurfacePrimary"
                  />
                </Box>
              ) : null}
            </Box>
          ))}
        </Box>
      </ScrollView>
    </Box>
  );
}

export default memo(QuestsInGameBottomSheet);
